// TODO: Hardik - remove console statements
import Image from 'next/image';
import Script from 'next/script';
import { useEffect, useState } from 'react';

import { staticMediaStoreBaseURL } from '@/config/common';
import {
  TAP_CARD_SDK_BASE_CONFIG,
  TAP_CARD_SDK_CONTAINER_ID,
  TAP_CARD_SDK_SCRIPT_URL,
  TAP_PAY_CURRENCY_CODE
} from '@/config/tapPayments';
import { isBrowser } from '@/lib/utils';
import { getSanitizedTapToken } from '@/services/payment.service';

const CardPayment = ({
  buttonBackgroundColorClass = 'bg-white',
  cardPaymentButtonClass = 'card-payment-button',
  onClickPayAmount,
  setTapSanitizedToken,
  textColorClass = 'text-brand',
  transactionAmount
}) => {
  const [validInput, setValidInput] = useState(false);

  useEffect(() => {
    if (!isBrowser()) {
      return undefined;
    }

    let unmountCard;

    const checkSDKLoaded = setInterval(() => {
      if (window.CardSDK) {
        clearInterval(checkSDKLoaded);

        const { renderTapCard } = window.CardSDK;
        const { unmount } = renderTapCard(TAP_CARD_SDK_CONTAINER_ID, {
          ...TAP_CARD_SDK_BASE_CONFIG,
          transaction: {
            amount: transactionAmount,
            currency: TAP_PAY_CURRENCY_CODE
          },
          onReady: () => console.debug('✅ onReady'),
          onFocus: () => console.debug('✅ onFocus'),
          onBinIdentification: (data) =>
            console.debug('✅ onBinIdentification', data),
          onValidInput: (data) => {
            console.debug('✅ onValidInputChange', data);
            setValidInput(data);
          },
          onInvalidInput: (data) => {
            console.debug('✅ onInvalidInput', data);
          },
          onError: (data) => console.error('❌ onError', data),
          onSuccess: async (data) => {
            console.debug('🎉 onSuccess', data);
            setTapSanitizedToken(getSanitizedTapToken({ token: data }));
            await onClickPayAmount();
          }
        });
        unmountCard = unmount;
      }
    }, 100);

    return () => {
      clearInterval(checkSDKLoaded);
      if (unmountCard) {
        unmountCard();
      }
    };
  }, [transactionAmount, setTapSanitizedToken, onClickPayAmount]);

  return (
    <div className='flex flex-col items-center gap-2'>
      <div className='w-full'>
        <Script
          src={TAP_CARD_SDK_SCRIPT_URL}
          strategy='afterInteractive'
        />
        <div
          className='w-full'
          id='tap-card-container'
        >
          <div id={TAP_CARD_SDK_CONTAINER_ID} />
          <button
            className={`ml-2 font-semibold py-2 rounded-lg flex items-center justify-center space-x-2 gap-1 mb-3 ${textColorClass} ${buttonBackgroundColorClass} ${
              !validInput ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'
            } ${cardPaymentButtonClass}`}
            disabled={!validInput}
            onClick={() => window.CardSDK.tokenize()}
          >
            <span>Pay with</span>
            <Image
              alt='card payment options'
              height={28}
              style={{ objectFit: 'contain' }}
              src={`${staticMediaStoreBaseURL}/icons/card-payment-options.svg`}
              width={62}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardPayment;
